import { Link } from "react-router-dom";
import { useState } from 'react'
import { useParams } from "react-router-dom";
import Footer from './Footer'
import './Login.css'
import { useTranslation } from "react-i18next";

const ResetPassword = () => {
  const { t } = useTranslation();

  const { shop } = useParams();
  const [email, setEmail] = useState('')

  const passwordReset = (e) => {
    e.preventDefault();
    
    fetch(process.env.REACT_APP_API_URL + '/sanctum/csrf-cookie', {
        method: 'GET',
        credentials: "include",
    }).then((response) => {
        let xsrfToken = document.cookie.split('; ').find(row => row.startsWith(process.env.REACT_APP_XSRF_TOKEN));
        if (xsrfToken) {
            xsrfToken = xsrfToken.split('=')[1];

            fetch(process.env.REACT_APP_API_URL + '/api/password/reset', {
                method: 'POST',
                cache: 'no-store',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': decodeURIComponent(xsrfToken),
                    'Accept': 'application/json',
                },
                credentials: "include",
                body: JSON.stringify({
                    shop_path: shop,
                    shop_user_id: email,
                }),
            }).then((response) => response.json())
            .then((data) => {
                if (data.message) {
                    alert(data.message);
                    return;
                } else {
                }
            }).catch((error) => {
                alert(error);
            });
        }
    }).catch((error) => {
        alert(error);
    });
}

  return (
    // ページを左右に分ける
    <div className="flex flex-row login-content">
        {/* 左側 */}
        <div className="w-1/2 login-content-left">
            <h1 className="text-center login-content-title">ORIPAL</h1>
            <div className="login-form-description">{t('reser_password.description')}</div>
            <form className="login-form">
                <label className="login-content-label">{t('reser_password.email')}</label>
                <input className="login-content-input-text" type="text" placeholder={t('reser_password.email')} value={email} onChange={(e) => setEmail(e.target.value)} />
                <button className="login-button" onClick={passwordReset}>{t('reser_password.submit')}</button>
            </form>
            <Link to={"/" + shop + "/login"} className="reset-password-link">{t('reser_password.back')}</Link>
            <Footer />
        </div>
        {/* 右側 */}
        <div className="w-1/2 login-content-right">
        </div>
    </div>
  )
}

export default ResetPassword